import { useState } from 'react';
import { MentionsList } from './MentionsList/MentionsList';
import {
  ACCORDION_CARD_CONTENT,
  buildRedirectUrl,
  divideMentionsByDate,
  getAllMentionIds,
  MENTIONS_LIST_TITLE
} from '../utils/mentionsColumn.utils';
import { IGroupedMention, MENTION_STATUS } from 'types/dashboard.types';
import { MentionSourceInfo } from './MentionSourceInfo/MentionSourceInfo';
import { MentionBulkActionsTrigger } from './MentionBulkActionsTrigger/MentionBulkActionsTrigger';

import './MentionAccordionCard.scss';

interface IMentionAccordionCardProps {
  groupedMention: IGroupedMention;
  status: MENTION_STATUS;
  reloadData: () => Promise<void>;
}

export const MentionAccordionCard = ({ groupedMention, status, reloadData }: IMentionAccordionCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { type, sourceId, sourceUuid } = groupedMention;
  const redirectUrl = buildRedirectUrl(type, sourceId, sourceUuid);

  const { icon, title } = ACCORDION_CARD_CONTENT[type];
  const redirectText = `${title} ${sourceId}`;

  const { todayMentions, previousMentions } = divideMentionsByDate(groupedMention);

  const allMentionIds = getAllMentionIds(groupedMention);

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const renderContent = () => {
    if (!isExpanded) {
      return (
        <span className="summary">
          <strong>{groupedMention.mentions.length}</strong> menciones
        </span>
      );
    }

    if (status === MENTION_STATUS.CLOSED) {
      return (
        <MentionsList
          mentions={[...todayMentions, ...previousMentions]}
          title={MENTIONS_LIST_TITLE[status].firstTitle}
          titleColor="#666666"
          redirectUrl={redirectUrl}
          reloadData={reloadData}
        />
      );
    }

    return (
      <>
        {todayMentions.length > 0 && (
          <MentionsList
            mentions={todayMentions}
            title={MENTIONS_LIST_TITLE[status].firstTitle}
            titleColor="#81BC3F"
            redirectUrl={redirectUrl}
            reloadData={reloadData}
          />
        )}

        {previousMentions.length > 0 && (
          <MentionsList
            mentions={previousMentions}
            title={MENTIONS_LIST_TITLE[status].secondTitle}
            titleColor="#666666"
            redirectUrl={redirectUrl}
            reloadData={reloadData}
          />
        )}
      </>
    );
  };

  return (
    <div className="mentionAccordionCardContainer">
      <div className={`mentionAccordionHeader ${isExpanded ? 'expanded' : ''}`} onClick={handleToggleExpanded}>
        <MentionSourceInfo icon={icon} redirectText={redirectText} redirectUrl={redirectUrl} isExpanded={isExpanded} />
        <MentionBulkActionsTrigger status={status} allMentionIds={allMentionIds} reloadData={reloadData} />
      </div>

      <div className="content">{renderContent()}</div>
    </div>
  );
};
